<template>
	<section class="page">
		<div :style="{'height': conH +'px'}" class="con-login">
			<status v-if="tabIndex==0" ref="status" @changeToMore='tabIndex = 3'></status>
			<order-list v-if="tabIndex==1"></order-list>
			<loan-market v-if="tabIndex==3"></loan-market>
			<mine v-if="showMine" @tapBg="closePop" />
		</div>
		<div ref="btn" class="btn tBor" v-show='isShowTab'>
			<a @click="tabIndex=0" :class="{'btn-a1': tabIndex == 0}">Home</a>
			<a @click="changeTab(1)" :class="{'btn-a2': tabIndex == 1}">Order</a>
			<div @click="changeTab(3)" class="btn-more">
				<div class="img-con">
					<img src="./img/selectTab3.png" v-if=' tabIndex == 3'>
					<img src="./img/tab3.png" v-else>
					<span class="un-read" v-if='isProduct'></span>
				</div>
				<div class="more" :class="{'btn-a3': tabIndex == 3}">More</div>
			</div>
			<a @click="changeTab(2)">My</a>
		</div>
		<service></service>
	</section>
</template>

<script>
	import orderList from './orderList'
	import status from "./status";
	import mine from "../my/mine.vue";
	import loanMarket from "./loanMarket.vue";
	import service from "@components/service";
	export default {
		data() {
			return {
				conH: '',
				tabIndex: this.UTILS.getQueryString('tab') || 0,
				showMine: false,
				deviceId: '',
				isShowTab:true,
				isProduct:false
			}
		},
		components: {
			status,
			orderList,
			loanMarket,
			mine,
			service
		},
		
		created(){
			this.UTILS.removeParam("moneyAmount");
			this.UTILS.removeParam("exchangeId");
			this.UTILS.removeParam("couponName");
			this.UTILS.removeParam("couponType");
			this.UTILS.removeParam("fqMoneyAmount");
			this.UTILS.removeParam("fqExchangeId");
			this.UTILS.removeParam("fqCouponName");
			this.UTILS.removeParam("fqCouponType");
			this.UTILS.removeParam('periods');
			this.UTILS.removeParam('amount');
			this.tabIndex = this.UTILS.getQueryString("tab") || 0;
			//app内嵌页面交互
			const phone = this.UTILS.getQueryString("phone") || "09270023183";
			var cToken = "";
			const cTime = this.UTILS.getParam('cTime');
			const preLoginTime = cTime && new Date(cTime).toDateString(); //前一次自动登录时间
			const curLoginTime = new Date().toDateString();
			const registerSource = this.UTILS.getQueryString("registerSource");//fb广告渠道来源
			if(registerSource){
				this.UTILS.setParam('registerSource',registerSource);
			}
			if(phone){//不同域名可能对应不同客服电话
				this.UTILS.setParam('phone',phone);
			}
			
			try{//安卓app
				cToken = funpera.getTokenFromApp();
				this.deviceId = funpera.getDeviceIdFromApp();
				this.UTILS.setParam('cToken', cToken);
				this.UTILS.setParam('deviceId', this.deviceId);
			}catch(e){
				if(this.UTILS.getEnv()){//ios app
					cToken = this.UTILS.getQueryString("cToken");
					this.deviceId = this.UTILS.getQueryString("deviceId");
					this.UTILS.setParam('cToken', cToken);
					this.UTILS.setParam('deviceId', this.deviceId);
				}
				else{
					cToken = this.UTILS.getParam('cToken');
				}
			}
			if(this.UTILS.getEnv()){//ios app
				this.isShowPage = true;
				this.isShowTab = false;
			}
			else{
				this.isShowTab = true;
				this.isShowPage = true;
			}
			
			if(cToken){
				if(!preLoginTime || preLoginTime !== curLoginTime){//判断是否同一天
					this.autoLogin()
				}
				this.getDcProductList()
			}
		},
		
		mounted: function() {
			var self = this;
			self.conH = window.innerHeight - self.$refs.btn.offsetHeight;
			window.addEventListener('resize', function() {
				self.conH = window.innerHeight - self.$refs.btn.offsetHeight;
			});
		},
		methods: {
			//关闭我的
			closePop(){
				var self = this;
				self.showMine = false;
			},
			
			changeTab(val){
				const cToken = this.UTILS.getParam('cToken');
				this.UTILS.removeParam("source");
				if(cToken){
					if(val == 2){
						this.showMine = true
					}
					else if(val == 3){
						if(!this.isProduct){
							this.UTILS.logStr("Repay on time 3 times and unlock more products – more to come!");
							return
						}
						this.tabIndex = val
					}
					else{
						this.tabIndex = val
					}
				}
				else{
					location.href = "./login.html"
				}
			},
			
			// 自动登录
			autoLogin() {
				var self = this;
				self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/user/autoLogin', {
					deviceId: self.UTILS.getParam('deviceId')
				}, function(res) {
					self.UTILS.loadGif.hide();
					if (res.code == '0000') {
						if(res.data){
							self.UTILS.setParam('cToken', res.data);
							self.UTILS.setParam('cTime', new Date());
						}
						else{
							self.UTILS.removeParam('cToken');
							self.UTILS.removeParam('cTime');
						}
					} else {
						self.UTILS.removeParam('cToken');
						self.UTILS.removeParam('cTime');
						self.UTILS.logStr(res.message);
					}
				}, 1);
			},
			
			getDcProductList() {
				this.UTILS.axiosRequest('post', this.PATHS.loanPath + '/dc/getDcProductList ', {}, (res) => {
					this.UTILS.loadGif.hide();
					if (res.code == '0000') {
						this.isProduct = res?.data?.length ? true : false;
					} else {
						this.isProduct = false;
						this.UTILS.logStr(res.message);
					}
				}, 1);
			},
		}
	}
</script>

<style scoped>
	@import "../../assets/css/onePx.css";

	.con-login {
		overflow: auto;
	}

	.btn {
		display: flex;
		align-items: center;
		height: 0.97rem;
		background-color: #FFF;
		position: relative;
	}

	.btn a {
		width: 25%;
		padding-top: 0.58rem;
		line-height: 0.3rem;
		text-align: center;
		font-size: 0.28rem;
		color: #BFBDBD;
	}
	.btn .btn-more{
		width: 25%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-top: 0.1rem;
	}
	.btn .btn-more .img-con{
		width: 0.5rem;
		position: relative;
	}
	.btn .btn-more img{
		width: 100%;
	}
	.btn .btn-more .more{
		line-height: 0.3rem;
		color: #BFBDBD;
	}
	.btn .btn-more .btn-a3{
		color: #ED7D31;
	}
	.btn .btn-more .un-read{
		position: absolute;
		top: 0;
		right: 0;
		width: 0.1rem;
		height: 0.1rem;
		border-radius: 50%;
		background: #FF0000;
	}
	.btn a:nth-child(1) {
		background: url("./img/tab1.png") no-repeat center 0.1rem;
		background-size: 0.4rem 0.44rem;
	}

	.btn a:nth-child(2) {
		background: url("./img/tab2.png") no-repeat center 0.1rem;
		background-size: 0.37rem 0.44rem;
	}
	.btn a:nth-child(4) {
		background: url("./img/tab4.png") no-repeat center 0.1rem;
		background-size: 0.4rem 0.4rem;
	}

	.btn a.btn-a1 {
		background: url("./img/selectTab1.png") no-repeat center 0.1rem;
		background-size: 0.4rem 0.44rem;
		color: #ED7D31;
	}

	.btn a.btn-a2 {
		background: url("./img/selectTab2.png") no-repeat center 0.1rem;
		background-size: 0.37rem 0.44rem;
		color: #ED7D31;
	}
	
	.btn a.btn-a3 {
		background: url("./img/selectTab3.png") no-repeat center 0.1rem;
		background-size: 0.5rem;
		color: #ED7D31;
	}
</style>
